<template>
    <div class="grid grid-cols-6 gap-6 mt-12">
        <div class="col-span-6 md:col-span-3 xl:col-span-4">
            <base-loading-indicator-box v-if="interruptionsLoading" class="mt-6">
            </base-loading-indicator-box>
            <div v-else>
                <base-list-with-heading>
                    <template v-slot:header>
                        <span class="text-base text-gray-800">Interruptions</span>
                    </template>

                    <incident-list-with-heading-entry v-for="incident in interruptions" :interruption="incident" :key="incident.id">
                    </incident-list-with-heading-entry>
                </base-list-with-heading>

                <base-card class="mt-6 text-gray-600 text-sm" v-if="Object.keys(interruptions).length === 0">
                    There are no interruptions in this summary. This can not happen Oo
                </base-card>
            </div>
        </div>

        <div class="col-span-6 md:col-span-3 xl:col-span-2">
            <base-heading-secondary text="Affected Hosts"></base-heading-secondary>

            <base-loading-indicator-box class="mt-6" v-if="affectedHostsLoading">
            </base-loading-indicator-box>
            <base-card class="mt-6 text-gray-600 text-sm" v-else>
                <ul>
                    <li v-for="host in affectedHosts" :key="host.id"><a :href="detailHostRoute(host)" v-html="host.name"></a></li>
                </ul>
            </base-card>
        </div>
        <rate-limit-exceeded-modal :open="rateLimitExceeded"></rate-limit-exceeded-modal>
    </div>
</template>

<script>
export default {
    props: {
        interruptionId: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            affectedHostsLoading: true,
            affectedHosts: Array,
            interruptionsLoading: true,
            interruptions: Object,
            rateLimitExceeded: false,
        }
    },
    methods: {
        handleRateLimit() {
            this.rateLimitExceeded = true;
        },

        fetchAffectedHosts() {
            this.affectedHostsLoading = true;

            axios.get(route('api.summary.hosts', {
                interruption: this.interruptionId
            })).then(function (response) {
                this.affectedHosts = response.data.hosts;

                this.affectedHostsLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        fetchInterruptions() {
            this.interruptionsLoading = true;

            axios.get(route('api.summary.interruptions', {
                interruption: this.interruptionId
            })).then(function (response) {
                this.interruptions = response.data.interruptions;

                this.interruptionsLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        refresh() {
            this.rateLimitExceeded = false;

            this.fetchAffectedHosts();
            this.fetchInterruptions();
        },
        detailHostRoute(host) {
            return route('host', {
                hostID: host.id
            });
        },
    },
    mounted() {
        this.$eventHub.$on('refresh', this.refresh);

        setTimeout(function () {
            this.refresh();
        }.bind(this), 1500);
    },
}
</script>
